import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import SiteButton from '@/elements/SiteButton.vue';
import utils from '@/utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'GridCardSectionCard',
  props: {
    card: {}
  },
  setup(__props: any) {

const props = __props;

const buttonFields = computed(() => utils.sc.getFieldObj(props.card, 'button')?.fields || {});

return (_ctx: any,_cache: any) => {
  const _component_SiteImage = _resolveComponent("SiteImage")!

  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass(_ctx.$style['c-grid-card-section-card'])
  }, [
    _createElementVNode("h3", {
      class: _normalizeClass(_ctx.$style['c-grid-card-section-card__title'])
    }, _toDisplayString(_unref(utils).sc.getFieldValue(__props.card, 'title', '')), 3),
    _createElementVNode("p", {
      class: _normalizeClass(_ctx.$style['c-grid-card-section-card__desc'])
    }, _toDisplayString(_unref(utils).sc.getFieldValue(__props.card, 'description', '')), 3),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style['c-grid-card-section-card__link'])
    }, [
      _createVNode(SiteButton, {
        fields: buttonFields.value,
        "default-type": "tertiary",
        size: "small",
        "icon-name": "arrow-right",
        "icon-size": "xxs"
      }, null, 8, ["fields"])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style['c-grid-card-section-card__decoration'])
    }, [
      _createVNode(_component_SiteImage, {
        field: _unref(utils).sc.getFieldObj(__props.card, 'cardDecorationImage')
      }, null, 8, ["field"])
    ], 2)
  ], 2))
}
}

})